import React, { useState } from 'react';

import PolicyForm from '../../../PolicyPlans/Form';
import PageTitleNew from '../../../ui/PageTitleNew';

import { usePolicyPlanTemplateContext } from '../../../../contexts/PolicyPlanTemplateContext';

export default function Edit({ onSuccessCreate, onCancel }) {
  const { dispatch, actions, state } = usePolicyPlanTemplateContext();

  const onSave = (values, onError) => {
    actions.update(
      dispatch,
      state.currentTemplate,
      values,
      () => {
        onSuccessCreate();
        actions.load(dispatch);
      },
      (errors) => {
        onError(errors);
      },
    );
  };

  const onCancelHandler = () => {
    onCancel();
  };

  return (
    <div className="wrapper_assestment invite_wrapper">
      <PageTitleNew title="Edit Plan Template" />

      <PolicyForm
        onSubmit={onSave}
        onCancel={onCancelHandler}
        template={state.currentTemplate}
      />
    </div>
  );
}
